import {interopDefault} from '~/utils/helpers'
import hotels from '@/routes/hotels'
import transfers from '@/routes/transfers'
import activities from '@/routes/activities'
import admin from '@/routes/admin'
import flights from '@/routes/flights'
import packages from '@/routes/packages'
import tours from '@/routes/tours'
import extraServices from '@/routes/extraServices'
import carsRent from '@/routes/carsRent'
import cruises from '@/routes/cruises'
import insurance from '@/routes/insurance'
import visa from '@/routes/visa'
import customRoutes from '~src/routes/customRoutes'
import simpleTours from '@/routes/simpleTours'
import routerMeta from '~src/routerMeta.json'
import deepmerge from 'deepmerge'

const IndexPage = () => interopDefault(import('~src/pages/indexPage.src'))
const OrderInfoPage = () => interopDefault(import('~/pages/OrderInfoPage'))
const RegistrationPage = () => interopDefault(import('~/pages/account/RegistrationPage'))
const PaymentCompletePage = () => interopDefault(import('~/pages/booking/PaymentCompletePage'))
const PaymentRedirectPage = () => interopDefault(import('~/pages/booking/PaymentRedirectPage'))
const OrdersPage = () => interopDefault(import('~src/pages/account/ordersPage.src'))
const B2cAuthorizationPage = () => interopDefault(import('~src/pages/account/b2cAuthorizationPage.src'))
const B2bAuthorizationPage = () => interopDefault(import('~src/pages/account/b2bAuthorizationPage.src'))
const OrderDetailsPage = () => interopDefault(import('~src/pages/account/orderDetailsPage.src'))
const SettingsPage = () => interopDefault(import('~/pages/account/SettingsPage'))
const CompanyProfilePage = () => interopDefault(import('~/pages/account/CompanyProfilePage'))
const AllPersonsPage = () => interopDefault(import('~/pages/account/AllPersonsPage'))
const AllCompaniesPage = () => interopDefault(import('~/pages/account/AllCompaniesPage'))
const RegistrationRequestPage = () => interopDefault(import('~/pages/account/RegistrationRequestPage'))
const CompanyPersonPage = () => interopDefault(import('~/pages/account/CompanyPersonPage'))
const CompanyClientsPage = () => interopDefault(import('~/pages/account/CompanyClientsPage'))
const CompanyClientPage = () => interopDefault(import('~/pages/account/CompanyClientPage'))
const CompanyCorporateClientsPage = () => interopDefault(import('~/pages/account/CompanyCorporateClientsPage'))
const CompanyAgenciesPage = () => interopDefault(import('~/pages/account/CompanyAgenciesPage'))
const RestorePasswordPage = () => interopDefault(import('~/pages/account/RestorePasswordPage'))
const InfoPage = () => interopDefault(import('~/pages/cms/InfoPage'))
const AutologinPage = () => interopDefault(import('~/pages/AutologinPage'))
const UserAutoLoginPage = () => interopDefault(import('~/pages/UserAutoLoginPage'))
const ReportsPage = () => interopDefault(import('~src/pages/account/reportsPage.src'))
const CompanyRegistrationPage = () => interopDefault(import('~src/pages/account/companyRegistrationPage.src'))
const InvoicePaymentCompletePage = () => interopDefault(import('~/pages/booking/InvoicePaymentCompletePage'))
const ManualInvoicePaymentCompletePage = () =>
    interopDefault(import('~/pages/booking/ManualInvoicePaymentCompletePage'))
const MembersPage = () => interopDefault(import('~/pages/account/MembersPage'))
const MemberPage = () => interopDefault(import('~/pages/account/MemberPage'))
const SupplierIndexPage = () => interopDefault(import('~/pages/supplier/SupplierPage'))
const SupplierProductsPage = () => interopDefault(import('~/pages/supplier/ProductsPage'))
const SupplierContractPage = () => interopDefault(import('~src/pages/supplier/ContractPage'))
const HotelsPage = () => interopDefault(import('~/pages/supplier/HotelDescriptionPage'))
const ActivityDescriptionPage = () => interopDefault(import('~/pages/supplier/ActivityDescriptionPage'))
const ResortPage = () => interopDefault(import('~src/pages/resortPage.src'))
const SchedulerPage = () => interopDefault(import('@/pages/scheduler/SchedulerPage'))
const FavoritesPage = () => interopDefault(import('~src/pages/favoritesPage.src'))
const BusinessIntelligencePage = () => interopDefault(import('@/pages/BusinessIntelligencePage'))
const KpisPage = () => interopDefault(import('~/pages/KpisPage.vue'))
const KpiPage = () => interopDefault(import('~/pages/KpiPage.vue'))
const PaymentsPage = () => interopDefault(import('~src/pages/PaymentsPage'))
const InvoicesPage = () => interopDefault(import('~src/pages/InvoicesPage'))
const CommunicationsPage = () => interopDefault(import('@/pages/CommunicationsPage'))
const CampaignsPage = () => interopDefault(import('@/pages/CampaignsPage'))
const CampaignPage = () => interopDefault(import('@/pages/CampaignPage'))
const CommunicationsCalendarPage = () => interopDefault(import('@/pages/CommunicationsCalendarPage.vue'))
const MessagesPage = () => interopDefault(import('~src/pages/MessagesPage'))
const FeedbackPage = () => interopDefault(import('@/pages/FeedbackPage.vue'))
const DashboardsPage = () => interopDefault(import('~src/pages/DashboardsPage.vue'))
const InboundEmailsPage = () => interopDefault(import('@/pages/InboundEmailsPage.vue'))
const CompanySuppliersPage = () => interopDefault(import('@/pages/account/CompanySuppliersPage.vue'))
const CompanySupplierPage = () => interopDefault(import('@/pages/account/CompanySupplierPage.vue'))
const SupplierPersonPage = () => interopDefault(import('~/pages/account/SupplierPersonPage'))
const LocationsPage = () => interopDefault(import('~/pages/account/LocationsPage'))
const VenuesPage = () => interopDefault(import('~/pages/account/VenuesPage'))
const ExchangeRatesPage = () => interopDefault(import('~/pages/account/ExchangeRatesPage'))
const VehicleTypesPage = () => interopDefault(import('~/pages/account/VehicleTypesPage'))
const VehicleTypePage = () => interopDefault(import('~/pages/account/VehicleTypePage'))
const SalesSettingsPage = () => interopDefault(import('~/pages/account/SalesSettingsPage'))
const PaymentsSettingsPage = () => interopDefault(import('~/pages/account/PaymentsSettingsPage'))
const OnlinePaymentsPage = () => interopDefault(import('~/pages/account/OnlinePaymentsPage'))

//TODO Set all route names to lowerCamelCase
const routesMergedWithMeta = [
    {
        path: '/',
        component: B2bAuthorizationPage,
        name: 'home',
        meta: {
            unwrapped: true,
            middleware: 'home',
        },
    },
    {
        path: '/tripAssistant/:id/:name',
        component: OrderInfoPage,
        name: 'tripAssistant',
    },
    {
        path: '/register',
        component: RegistrationPage,
        name: 'register',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/payment-complete',
        component: PaymentCompletePage,
        name: 'paymentComplete',
        meta: {
            layout: 'centered',
        },
    },
    {
        path: '/payment-redirect',
        component: PaymentRedirectPage,
        name: 'paymentRedirect',
        meta: {
            layout: 'pure',
            middleware: 'test',
        },
    },
    {
        path: '/orders',
        component: OrdersPage,
        name: 'orders',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/authorization',
        component: B2cAuthorizationPage,
        name: 'authorization',
        meta: {
            unwrapped: true,
        },
    },
    {
        path: '/b2b-auth',
        component: B2bAuthorizationPage,
        name: 'b2b-auth',
        meta: {
            unwrapped: true,
            middleware: 'auth',
        },
    },
    {
        path: '/b2b-register',
        component: CompanyRegistrationPage,
        name: 'b2b-register',
        alias: ['/registration-requests/new', '/registration-requests/edit'],
    },
    {
        path: '/orders/:id',
        component: OrderDetailsPage,
        name: 'order-details',
        meta: {
            middleware: 'order-auth',
            unwrapped: true,
        },
    },
    {
        path: '/settings',
        component: SettingsPage,
        name: 'user-settings',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/agency/profile',
        component: CompanyProfilePage,
        name: 'company-profile',
        alias: '/company/profile',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/agency/company/:id',
        component: CompanyProfilePage,
        name: 'company-client-profile',
        alias: '/company/:id',
        meta: {
            middleware: 'auth',
            keepalive: true,
        },
    },
    {
        path: '/agency/users',
        component: CompanyProfilePage,
        name: 'companyPersons',
        alias: '/company/users',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/users',
        component: AllPersonsPage,
        name: 'allPersons',
        alias: '/users',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/companies',
        component: AllCompaniesPage,
        name: 'allCompanies',
        alias: '/companies',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/registration-requests',
        component: RegistrationRequestPage,
        name: 'registrationRequests',
        alias: '/registration-requests',
        meta: {
            middleware: ['auth', () => (!runtimeStore.CRMSettings.extendedCrm ? abortNavigation() : null)],
        },
    },
    {
        path: '/agency/:companyId/users/:id',
        component: CompanyPersonPage,
        name: 'companyPerson',
        alias: '/company/:companyId/users/:id',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/agency/clients',
        component: CompanyClientsPage,
        name: 'companyClients',
        alias: '/company/clients',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/agency/clients/:id',
        component: CompanyClientPage,
        name: 'companyClient',
        alias: '/company/clients/:id',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/agency/corporate-clients',
        component: CompanyCorporateClientsPage,
        name: 'companyCorporateClients',
        alias: '/company/corporate-clients',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/agency/agencies',
        component: CompanyAgenciesPage,
        name: 'companyAgencies',
        alias: '/company/agencies',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/restore-password',
        component: RestorePasswordPage,
        name: 'restore-password',
    },
    {
        path: '/info/:link',
        component: InfoPage,
        name: 'infoPage',
    },
    {
        path: '/autologin',
        component: AutologinPage,
        name: 'autologin',
    },
    {
        path: '/userAutoLogin',
        component: UserAutoLoginPage,
        name: 'userAutoLogin',
    },
    {
        path: '/reports',
        component: ReportsPage,
        name: 'reports',
    },
    {
        path: '/invoice-payment-complete',
        component: InvoicePaymentCompletePage,
        name: 'invoicePaymentComplete',
        meta: {
            layout: 'centered',
        },
    },
    {
        path: '/manual-invoice-payment-complete',
        component: ManualInvoicePaymentCompletePage,
        name: 'manualInvoicePaymentCompletePage',
        meta: {
            layout: 'centered',
        },
    },
    {
        path: '/members',
        component: MembersPage,
        name: 'members',
        alias: '/user/members',
        meta: {
            middleware: ['auth', 'members'],
        },
    },
    {
        path: '/members/:id',
        component: MemberPage,
        name: 'member',
        alias: '/user/members/:id',
        meta: {
            middleware: ['auth', 'members'],
        },
    },
    {
        path: '/company/suppliers',
        component: CompanySuppliersPage,
        name: 'companySuppliers',
        alias: '/company/suppliers',
        meta: {
            middleware: ['auth'],
        },
    },
    {
        path: '/company/suppliers/:id',
        component: CompanySupplierPage,
        name: 'companySupplier',
        alias: '/company/suppliers/:id',
        meta: {
            middleware: ['auth'],
        },
    },
    {
        path: '/supplier/:companyId/users/:id',
        component: SupplierPersonPage,
        name: 'supplierPerson',
        meta: {
            middleware: ['auth'],
        },
    },
    {
        path: '/supplier',
        component: SupplierIndexPage,
        name: 'supplier',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/supplier/products',
        component: SupplierProductsPage,
        name: 'supplierProducts',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/supplier/products/:contractId',
        component: SupplierContractPage,
        name: 'supplierContract',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/supplier/hotels/:hotelId',
        component: HotelsPage,
        name: 'hotelDescription',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/supplier/activity/:activityId',
        component: ActivityDescriptionPage,
        name: 'activityDescription',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/resort/:link',
        component: ResortPage,
        name: 'resort',
        meta: {
            unwrapped: true,
        },
    },
    {
        path: '/scheduler',
        component: SchedulerPage,
        name: 'scheduler',
        meta: {
            middleware: ['auth', 'forbidden'],
        },
    },
    {
        path: '/favorites',
        component: FavoritesPage,
        name: 'favorites',
    },
    {
        path: '/business-intelligence',
        component: BusinessIntelligencePage,
        name: 'businessIntelligence',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/kpis',
        component: KpisPage,
        name: 'kpis',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/kpis/:id',
        component: KpiPage,
        name: 'kpi',
        alias: '/kpis/:id',
        meta: {
            middleware: ['auth'],
        },
    },
    {
        path: '/payments',
        component: PaymentsPage,
        name: 'payments',
        meta: {
            middleware: ['auth', 'forbidden'],
        },
    },
    {
        path: '/invoices',
        component: InvoicesPage,
        name: 'invoices',
        meta: {
            middleware: ['auth', 'forbidden'],
        },
    },
    {
        path: '/communications',
        component: CommunicationsPage,
        name: 'communications',
        meta: {
            middleware: ['auth', 'to1-access-only'],
        },
    },
    {
        path: '/messages',
        component: MessagesPage,
        name: 'messages',
        meta: {
            middleware: ['auth'],
        },
    },
    {
        path: '/campaigns',
        component: CampaignsPage,
        name: 'campaigns',
        meta: {
            middleware: ['auth', 'to1ds-access-only'],
        },
    },
    {
        path: '/campaigns/:id',
        component: CampaignPage,
        name: 'campaign-details',
        meta: {
            middleware: ['auth', 'to1ds-access-only'],
        },
    },
    {
        path: '/my-calendar',
        component: CommunicationsCalendarPage,
        name: 'communicationsCalendar',
        meta: {
            middleware: ['auth', 'forbidden'],
        },
    },
    {
        path: '/feedback',
        component: FeedbackPage,
        name: 'feedback',
        meta: {
            middleware: ['auth', 'forbidden'],
        },
    },
    {
        path: '/dashboards',
        component: DashboardsPage,
        name: 'dashboards',
        meta: {
            middleware: ['auth', 'forbidden'],
        },
    },
    {
        path: '/inbound-emails',
        component: InboundEmailsPage,
        name: 'inboundEmails',
        meta: {
            middleware: ['auth', 'forbidden'],
        },
    },
    {
        path: '/exchange-rates',
        component: ExchangeRatesPage,
        name: 'exchangeRates',
        meta: {
            middleware: ['auth', 'forbidden'],
        },
    },
    {
        path: '/locations',
        component: LocationsPage,
        name: 'locations',
        alias: '/locations',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/venues',
        component: VenuesPage,
        name: 'venues',
        alias: '/venues',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/vehicleTypes',
        component: VehicleTypesPage,
        name: 'vehicleTypes',
        alias: '/vehicleTypes',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/vehicleTypes/:id',
        component: VehicleTypePage,
        name: 'vehicleType',
        alias: '/vehicleTypes/:id',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/salesSettings',
        component: SalesSettingsPage,
        name: 'salesSettings',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/paymentsSettings',
        component: PaymentsSettingsPage,
        name: 'paymentsSettings',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/onlinePayments',
        component: OnlinePaymentsPage,
        name: 'onlinePayments',
        meta: {
            middleware: 'auth',
        },
    },
    ...hotels,
    ...transfers,
    ...activities,
    ...flights,
    ...admin,
    ...packages,
    ...tours,
    ...extraServices,
    ...carsRent,
    ...insurance,
    ...visa,
    ...customRoutes,
    ...cruises,
    ...simpleTours,
].map(el => {
    const objectWithMeta = routerMeta.find(r => r.name === el.name)

    if (!objectWithMeta) {
        return el
    }

    delete objectWithMeta.pathForSupport

    return deepmerge(el, objectWithMeta)
})

export const routes = routesMergedWithMeta
